'use strict';

import { Entity } from '../Entity';

export class IndPhone extends Entity {
  protected indPhoneId;
  protected indId = '0';
  protected indPhoneOwner;
  protected indPhoneType;
  protected indPhoneNumber;
  protected indPhonePref;
  protected indPhoneDisc;
  protected indPhoneDnc;

  constructor() {
    super();
  }

  public hydrate(data: any) {
    this.indPhoneId = data.indPhoneId;
    this.indId = data.indId;
    this.indPhoneOwner = data.indPhoneOwner;
    this.indPhoneType = data.indPhoneType;
    this.indPhoneNumber = data.indPhoneNumber;
    this.indPhonePref = data.indPhonePref;
    this.indPhoneDisc = data.indPhoneDisc;
    this.indPhoneDnc = data.indPhoneDnc;
  }

  public getIndPhoneId() {
    return this.indPhoneId;
  }

  public getIndId() {
    return this.indId;
  }

  public getIndPhoneOwner() {
    return this.indPhoneOwner;
  }

  public getIndPhoneType() {
    return this.indPhoneType;
  }

  public setIndPhoneType(indPhoneType) {
    this.indPhoneType = indPhoneType;

    return this;
  }

  public getIndPhoneNumber() {
    return this.indPhoneNumber;
  }

  public setIndPhoneNumber(indPhoneNumber) {
    this.indPhoneNumber = indPhoneNumber;

    return this;
  }

  public getIndPhonePref() {
    return this.indPhonePref;
  }

  public getIndPhoneDisc() {
    return this.indPhoneDisc;
  }

  public getIndPhoneDnc() {
    return this.indPhoneDnc;
  }
}
